import React from 'react';
import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack, { StackProps } from '@mui/material/Stack';

interface ItemSwitchProps extends StackProps {
  itemLeft: React.ReactNode;
  itemRight: React.ReactNode;
  leftChecked: boolean;
  onChange: () => void;
}

const ItemSwitch: React.FC<ItemSwitchProps> = ({
  itemLeft,
  itemRight,
  leftChecked,
  onChange,
  sx,
  ...props
}) => {
  const theme = useTheme();

  return (
    <React.Fragment>
      <Stack
        direction="row"
        alignItems="center"
        sx={{
          backgroundColor: theme.palette.background.default,
          borderRadius: theme.spacing(1),
          position: 'relative',
          width: 'max-content',
          ':before': {
            content: "''",
            position: 'absolute',
            left: leftChecked ? 0 : '50%',
            width: '50%',
            backgroundColor: theme.palette.divider,
            top: 0,
            bottom: 0,
            transition: 'all 0.4s ease-in-out',
            borderRadius: theme.spacing(1),
          },
          ...sx,
        }}
        {...props}
      >
        <Button
          sx={{ transition: 'color 0.4s ease-in-out', color: leftChecked ? 'primary' : 'GrayText' }}
          onClick={onChange}
        >
          {itemLeft}
        </Button>
        <Button
          sx={{ transition: 'color 0.4s ease-in-out', color: leftChecked ? 'GrayText' : 'primary' }}
          onClick={onChange}
        >
          {itemRight}
        </Button>
        <Box sx={{}} />
      </Stack>
    </React.Fragment>
  );
};

export default ItemSwitch;
